import axios from 'axios';

export interface MapInitialView {
  lat: number;
  lng: number;
  zoom: number;
}

/** Fallback en caso de que el backend no responda (mismos valores que el default en backend). */
export const DEFAULT_MAP_INITIAL_VIEW: MapInitialView = {
  lat: 4.711595999012947,
  lng: -74.22575179114611,
  zoom: 14
};

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3009/api/v1';

let cache: MapInitialView | null = null;
let inflight: Promise<MapInitialView> | null = null;

function isFiniteNumber(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value);
}

/**
 * Obtiene la vista inicial del mapa desde el backend (GET /config/map).
 * Cachea el resultado por vida del bundle; si la petición falla, cae al default.
 */
export async function getMapInitialView(): Promise<MapInitialView> {
  if (cache) return cache;
  if (inflight) return inflight;

  inflight = (async () => {
    try {
      const { data } = await axios.get(`${API_URL}/config/map`);
      const payload = data?.data ?? data ?? {};
      const view: MapInitialView = {
        lat: isFiniteNumber(payload.lat) ? payload.lat : DEFAULT_MAP_INITIAL_VIEW.lat,
        lng: isFiniteNumber(payload.lng) ? payload.lng : DEFAULT_MAP_INITIAL_VIEW.lng,
        zoom: isFiniteNumber(payload.zoom) ? payload.zoom : DEFAULT_MAP_INITIAL_VIEW.zoom
      };
      cache = view;
      return view;
    } catch {
      cache = DEFAULT_MAP_INITIAL_VIEW;
      return DEFAULT_MAP_INITIAL_VIEW;
    } finally {
      inflight = null;
    }
  })();

  return inflight;
}

/** Devuelve el valor cacheado (si ya se resolvió) o el default. Útil como valor síncrono inicial. */
export function getMapInitialViewSync(): MapInitialView {
  return cache ?? DEFAULT_MAP_INITIAL_VIEW;
}
